import { useTranslation } from 'react-i18next';
import React from "react";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { Table, Button } from "antd";
import { formatNum, momentFormat } from "@/erp_subpackage/utils/util";
import { usePsiModel } from "../../psiModel";


export const DetailsTable = ({ dataSource, recordType, loading, exportDetail, ...props }) => {
	const { t } = useTranslation();
	const {
		setDatailsVisible
	} = usePsiModel();
	const obj = {
		io_spd: t(`stock.RemainNumModal.detailsTable.采购`),
		io_sprd: t(`stock.RemainNumModal.detailsTable.采退`),
		io_ssd: t(`stock.RemainNumModal.detailsTable.销售`),
		io_ssrd: t(`stock.RemainNumModal.detailsTable.销退`),
		io_vmm: t(`stock.RemainNumModal.detailsTable.维修`),
		io_vrm: t(`stock.RemainNumModal.detailsTable.维退`),
	}

	const columns = [
		{
			title: t(`stock.RemainNumModal.detailsTable.序号`),
			width: 66,
			align: "center",
			render: (t, r, i) => i + 1
		}, {
			title: t(`stock.RemainNumModal.detailsTable.业务日期`),
			width: 180,
			align: "center",
			dataIndex: 'createTime',
		}, {
			title: t(`stock.RemainNumModal.detailsTable.单据编号`),
			width: 120,
			align: "center",
			dataIndex: 'code',
			render: (text, record, index) => <span className="click-span" onClick={(e) => setDatailsVisible({
				visible: true,
				code: text,
				type: record.type
			})}> {text}</span >,
		}, {
			title: t(`stock.RemainNumModal.detailsTable.单价`),
			width: 160,
			align: "center",
			dataIndex: 'price',
			render: text => `￥${formatNum(text)}`
		}, {
			title: t(`stock.RemainNumModal.detailsTable.数量`),
			width: 140,
			align: "center",
			dataIndex: 'num',
		}, {
			title: t(`stock.RemainNumModal.detailsTable.金额`),
			width: 120,
			align: "center",
			render: (text, record) => `￥${formatNum(record.num * record.price)}`
		}
	];


	const action = <Button
		className="btn-item"
		shape="round"
		onClick={() => exportDetail()}
	> {t(`stock.RemainNumModal.detailsTable.导出`)}</Button>


	const desc = [
		{
			label: `${obj[recordType]}${t(`stock.RemainNumModal.detailsTable.数量`)}`,
			value: dataSource.reduce((c, n) => { c = c + n.num; return c }, 0).toFixed(2),
			color: "red"
		},
	]

	return <YhBox title={action} descriptions={desc}>
		<Table
			loading={loading}
			rowKey={record => record.id}
			columns={columns}
			dataSource={dataSource}
			pagination={false}
			scroll={{ x: 'max-content', y: 340 }}
		/>
	</YhBox>
}